import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function PrivacyOptions(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg {...props} viewBox='0 0 30 14'>
      <g clipPath='url(#clip0_1201_3460)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.39961 12.8012H14.1996L17.2996 1.20117H7.39961C4.19961 1.20117 1.59961 3.80117 1.59961 7.00117C1.59961 10.2012 4.19961 12.8012 7.39961 12.8012Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22.5999 0.000976562H7.3999C3.4999 0.000976562 0.399902 3.10098 0.399902 7.00098C0.399902 10.901 3.4999 14.001 7.3999 14.001H22.5999C26.4999 14.001 29.5999 10.901 29.5999 7.00098C29.5999 3.10098 26.3999 0.000976562 22.5999 0.000976562ZM1.5999 7.00098C1.5999 3.80098 4.1999 1.20098 7.3999 1.20098H17.2999L14.1999 12.801H7.3999C4.1999 12.801 1.5999 10.201 1.5999 7.00098Z'
          fill='#0066FF'
        />
        <path
          d='M24.5997 4.00059C24.7997 4.20059 24.7997 4.60059 24.5997 4.80059L22.4997 7.00059L24.6997 9.20059C24.8997 9.40059 24.8997 9.80059 24.6997 10.0006C24.4997 10.2006 24.0997 10.2006 23.8997 10.0006L21.6997 7.80059L19.4997 10.0006C19.2997 10.2006 18.8997 10.2006 18.6997 10.0006C18.4997 9.80059 18.4997 9.40059 18.6997 9.20059L20.7997 7.00059L18.5997 4.80059C18.3997 4.60059 18.3997 4.20059 18.5997 4.00059C18.7997 3.80059 19.1997 3.80059 19.3997 4.00059L21.5997 6.20059L23.7997 4.00059C23.9997 3.80059 24.3997 3.80059 24.5997 4.00059Z'
          fill='white'
        />
        <path
          d='M12.7 4.10117C12.9 4.30117 13 4.70117 12.8 4.90117L8.6 9.80117C8.5 9.90117 8.4 10.0012 8.3 10.0012C8.1 10.1012 7.8 10.1012 7.6 9.90117L5.4 7.70117C5.2 7.50117 5.2 7.10117 5.4 6.90117C5.6 6.70117 6 6.70117 6.2 6.90117L8 8.60117L11.8 4.10117C12 3.90117 12.4 3.90117 12.7 4.10117Z'
          fill='#0066FF'
        />
      </g>
      <defs>
        {/** biome-ignore lint/correctness/useUniqueElementIds: Automated migration to Biome */}
        <clipPath id='clip0_1201_3460'>
          <rect
            width='30'
            height='14'
            fill='white'
            transform='translate(0 0.000976562)'
          />
        </clipPath>
      </defs>
    </BaseLibraryIconSvg>
  );
}
